export function capitalize(value: string): string {
  if (!value || !isString(value)) return ''
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export const castToFloat = (
  value: string | number | null | undefined
): number => {
  if (!value || Number.isNaN(value)) {
    return 0
  }

  if (typeof value === 'number') {
    return value
  }

  // Convert commas to dots, remove all dots except the last one
  return parseFloat(value.replace(/,/g, '.').replace(/\.(?=.*\.)/g, ''))
}

function isString(value: string): boolean {
  return typeof value === 'string'
}

export const stringToQuote = (str: string): string => {
  if (!str || str.length === 0) return ''

  return (
    str
      .trim()
      .split('\n')
      .map((s) => `> ${s}`)
      .join('\n') + '\n\n'
  )
}

export const arrayToSentence = (array: Array<string>): string => {
  if (array.length === 0) return ''
  if (array.length === 1) return array[0]

  return (
    array.slice(0, -1).join(', ') +
    window.I18n.t('support.array.last_word_connector') +
    array[array.length - 1]
  )
}

export function decodeHtmlChars(html: string): string {
  const tempDivElement: HTMLElement = document.createElement('div')
  tempDivElement.innerHTML = html

  return tempDivElement.textContent || tempDivElement.innerText || ''
}
